module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_5.3a58e782.png";